<template>
  <div>
    <div>
      <p v-if="!this.$store.state.guestLogin.createContact">Below is your existing contact information. If the contact information has been validated earlier with Multi Factor Authentication (MFA) it will have a green check against it.
        To update your contact information or to verify it, please check the box against the contact that you want to update / verify and click on 'Next'
        
        <span v-if="this.$store.state.guestLogin.createContact">Please enter your contact information below and click on 'Next'. We will send you a login code to your new contact information.</span> <br />
        <span v-if="this.$store.state.guestLogin.createContact">
          Login code will be valid for limited time. Enter the login code on the following screen and upon successful login code validation your contact information will be updated and you will be navigated
          to your RI DMV Online Customer profile. Your contact information will be used for future electronic Multi Factor Authentication (MFA).
        </span>  
      </p>
      <div class="user-info">
        <label>Email</label> 
        <div class="user-info-group">
          <div class="user-info-group-contact">
            <label for="email" class="user-info-email">{{ personalInfo.personalInformation && personalInfo.personalInformation.email ? personalInfo.personalInformation.email : 'No email on file' }}</label>
            <img v-if="personalInfo.personalInformation && personalInfo.personalInformation.isEmailVerified == true" class="verify-icon" src="static/verified-icon.png" alt="Email is verified">
          </div>
          <div class="user-info-group-contact">
            <input type="checkbox" v-model="updateEmail" @change="errMsg=''">
            <label>Update <span class="sep-class">/</span> Verify</label>
          </div>
        </div>
      </div>

      <div class="user-info">
        <div class="user-phone-header">
          <label>Phone</label><span class="user-phone-details"><strong>(Message and data rates may apply)</strong></span>
        </div> 
        <div class="user-info-group">
          <div class="user-info-group-contact">
            <label for="phone" class="user-info-email">{{ personalInfo.personalInformation && personalInfo.personalInformation.phone ? personalInfo.personalInformation.phone : 'No phone on file' }}</label>
            <img v-if="personalInfo.personalInformation && personalInfo.personalInformation.isPhoneVerified == true" class="verify-icon" src="static/verified-icon.png" alt="Phone is verified">
          </div>
          <div class="user-info-group-contact">
            <input type="checkbox" v-model="updatePhone" @change="errMsg=''">
            <label>Update <span class="sep-class">/</span> Verify</label>
          </div>
        </div>
      </div>
    </div>
    <p v-if="errMsg" class="err-msg">{{ errMsg }}</p>
    <p v-if="errMsg" class="sr-only">{{ errMsg }}</p>
    <BaseButtonGroup>
      <button type="button" @click="handleRouting('previous')">Previous</button>
      <button type="submit" class="app-btn-primary" @click.prevent="handleRouting('next')">
        Next
      </button>
    </BaseButtonGroup>
  </div>
</template>



<script>
import * as COMMONS from '../../store/_commons';
import { mapGetters, mapActions } from 'vuex';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';

export default {
  name: 'ContactUpdate',
  components: {
    BaseButtonGroup
},
  data() {
    return {
      screenData: {},
      updateEmail: false,
      updatePhone: false,
      errMsg: ''
    }
  },
  computed: {
    ...mapGetters({
        personalInfo: COMMONS.GUEST_PERSONAL_INFO,
    }),
    contactInfo() {
      return this.$store.state.guestLogin.loginUserDetails;
    }
  },
  created() {

  },
  mounted() {
    window.scroll(0,0);
    document.body.setAttribute("tabindex", "1");
    document.body.focus();

    document.body.removeAttribute("tabindex");
    document.getElementById("app").scrollTop = 0;
  },
  watch: {

  },
  methods: {

    ...mapActions({
      getUpdateContact: COMMONS.GUEST_UPDATE_CONTACT
    }),

    async handleRouting(info) {
      if(info=='previous') {
         if(this.contactInfo && this.contactInfo.isPaperOtpSent) {
          this.$router.push({ path : '/guest-signin' });
        }
        else {
          this.$router.push({ path : '/profile' });
        }
      }
      else if (info=='next') {
        if(this.updateEmail || this.updatePhone) {
          let data = {
            email: this.updateEmail,
            phone: this.updatePhone
          }
          this.getUpdateContact(data);
          this.errMsg = '';
        } else {
          this.errMsg = 'Please select the contact information to update/verify'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.user-info {
  margin-top: 2rem;
  h3 {
    color: #000;
  }
  .user-phone-header{
    display: flex;
    align-items: baseline;
    .user-phone-details{
      margin-left: 5px;
    }
  }
  .user-info-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 3rem;
    .user-info-group-contact {
      width: 300px;
      padding: 20px 0;
      display: flex;
      .verify-icon {
        width: 50px;
        height: 20px;
        vertical-align: middle;
        margin-left: 5px;
      }
      .user-info-email{
        width: 90%;
        word-wrap: break-word;
      }
      .sep-class{
        margin: 0 3px 0 2px;
      }
    }

    @media (min-width: 355px) and (max-width: 700px) {

      margin-bottom: 15px;
      .user-info-group-contact {
        padding: 5px 0;
      }
    }
  }

  @media (min-width: 355px) and (max-width: 740px) {
    .user-phone-header{
      display: block;
      .user-phone-details{
        margin-left: 0px !important;
      }
    }
    .user-info-group {
      gap: 0rem;
    } 
  }
}
.err-msg{
  color: var(--ri-red);
}
</style>